import { useState } from "react";
import { deleteCategory } from "../../api/tournaments";
import { ConfirmDialog, Field, Input } from "../../ui";
import "./styles.scss";

type DeleteCategoryDialogProps = {
  categoryName: string;
  categoryId: string;
  isOpen: boolean;
  onClose: (update?: boolean) => void;
};

const DeleteCategoryDialog = (props: DeleteCategoryDialogProps) => {
  const [name, setName] = useState("");
  const matches = name === props.categoryName;

  const handleDelete = async () => {
    if (!matches) return;
    // A failed delete throws: ConfirmDialog stays open (the API interceptor reports the error)
    await deleteCategory(props.categoryId);
  };

  return (
    <ConfirmDialog
      open={props.isOpen}
      onClose={(confirmed) => props.onClose(confirmed || undefined)}
      onConfirm={handleDelete}
      title="Are you sure?"
      message="This action cannot be undone. If you delete this category, you will lose all details."
      confirmLabel="Delete"
      confirmDisabled={!matches}
    >
      <Field className="delete-category-dialog__field" label="Type the name of the category to delete it">
        {(id) => <Input id={id} value={name} placeholder={props.categoryName} onChange={(e) => setName(e.target.value)} />}
      </Field>
    </ConfirmDialog>
  );
};

export default DeleteCategoryDialog;
